import React        from 'react'

const Container = props => {
    return (
        <div className="services-details-container">
            { props.children }
        </div>
    )
}

export default Container
